export default [
  // PUBLIC
  {
    path: '/login',
    name: 'login',
    component: () => import('views/public/Login'),
  },
  {
    path: '/registration',
    name: 'registration',
    component: () => import('views/public/Registration'),
  },
  {
    path: '/referral/:code',
    redirect: {
      name: 'registration',
    },
  },
  {
    path: '/registration/account',
    name: 'registration.account',
    component: () => import('views/public/AccountCreating'),
  },
  {
    path: '/registration/currency',
    name: 'registration.currency',
    component: () => import('views/public/ProjectCurrency'),
    props: true,
  },
  {
    path: '/restore',
    name: 'restore.password',
    component: () => import('views/public/PasswordRestore'),
    props: true,
  },
  // TODO: запросить бэкенд передевать роут на restore/confirm
  {
    path: '/restoreFromEmail/:key',
    name: 'restore.confirm',
    component: () => import('views/public/ConfirmationRestore'),
  },
  {
    path: '/email-confirmation',
    name: 'email-confirmation',
    component: () => import('@/pages/identification/EmailConfirmation'),
  },
  {
    path: '/bot/telegram/subscribe',
    name: 'telegramBotBinding',
    component: () => import('@/pages/identification/TelegramBotBinding'),
  },
  // PUBLIC OLD
  {
    path: '/secure',
    name: 'threeDSecure',
    component: () => import('@/pages/3ds/ThreeDSecure'),
    props: true,
  },

  // PRIVATE
  {
    path: '/cabinet',
    name: 'cabinet',
    component: () => import('@/pages/main/Cabinet'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/editproject',
    name: 'editProject',
    component: () => import('@/pages/main/EditProject'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/bill',
    name: 'Invoicing',
    component: () => import('@/pages/invoicing/Invoicing'),
    meta: {
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: '/billresult',
    name: 'InvoicingResult',
    component: () => import('@/pages/invoicing/InvoicingResult'),
    meta: {
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: '/payout',
    name: 'payout',
    component: () => import('views/private/payout/Payout'),
    meta: {
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: '/card/binding',
    name: 'card.binding',
    component: () => import('views/private/card/CardBinding'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/cardselectedmessage',
    name: 'cardSelectedMessage',
    component: () => import('@/pages/alertMessages/CardSelectedMessage'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/cardselect',
    name: 'cardSelect',
    component: () => import('@/pages/main/CardSelect'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/cardconfirmation',
    name: 'cardConfirmation',
    component: () => import('@/pages/identification/CardConfirmation'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/wallet/binding',
    name: 'wallet.binding',
    component: () => import('views/private/wallet/WalletBinding'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/wallet/select',
    name: 'wallet.select',
    component: () => import('views/private/wallet/WalletSelect'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/wallet/confirmation',
    name: 'wallet.confirmation',
    component: () => import('views/private/wallet/WalletConfirmation'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/identification/myid',
    name: 'identification.myid',
    component: () => import('views/private/identification/IdentifacationMyID'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/currency',
    name: 'project.currency',
    component: () => import('views/private/project/ProjectCurrency'),
    meta: {
      requiresAuth: false,
    },
  },
];
